import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', {
    created(el, binding) {
      el.eventSetDrag = function () {
        el.setAttribute('data-dragging', 'yes')
      }
      el.eventClearDrag = function () {
        el.removeAttribute('data-dragging')
      }
      el.eventOnClick = function (event) {
        const dragging = el.getAttribute('data-dragging')

        const whitelist = ['nuxt-link', '.search-results']

        const isExcluded = whitelist.some((selector) =>
          event.target.closest(selector),
        )
        // Check that the click was outside the element and its children, and wasn't a drag
        if (
          !(el === event.target || el.contains(event.target)) &&
          !dragging &&
          !isExcluded
        ) {
          // Call the method provided in the directive value
          if (typeof binding.value === 'function') {
            binding.value(event)
          }
        }
      }
      document.addEventListener('touchstart', el.eventClearDrag)
      document.addEventListener('touchmove', el.eventSetDrag)
      document.addEventListener('click', el.eventOnClick)
      document.addEventListener('touchend', el.eventOnClick)
    },
    unmounted(el) {
      document.removeEventListener('touchstart', el.eventClearDrag)
      document.removeEventListener('touchmove', el.eventSetDrag)
      document.removeEventListener('click', el.eventOnClick)
      document.removeEventListener('touchend', el.eventOnClick)
      el.removeAttribute('data-dragging')
    },
  })
})
